import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ChangePasswordComponent } from './components/auth/pages/change-password/change-password.component';
import { ForgotPasswordComponent } from './components/auth/pages/forgot-password/forgot-password.component';
import { OtpComponent } from './components/auth/pages/otp/otp.component';
import { ResetPasswordComponent } from './components/auth/pages/reset-password/reset-password.component';
import { SignInComponent } from './components/auth/pages/sign-in/sign-in.component';
import { AccessRestrictionComponent } from './components/sidenav/pages/access-restriction/access-restriction.component';
// import { CreateBatchComponent } from './components/sidenav/pages/create-batch/create-batch.component';
// import { ListOfChallansComponent } from './components/sidenav/pages/list-of-challans/list-of-challans.component';
// import { OnboardContainerComponent } from './components/sidenav/pages/onboard-container/onboard-container.component';
// import { ViewChallanComponent } from './components/sidenav/pages/view-challan/view-challan.component';
// import { ViewSingleChallanComponent } from './components/sidenav/pages/view-single-challan/view-single-challan.component';
import { SideNavComponent } from './components/sidenav/sidenav.component';
import { AuthGuard } from './guards/auth.guard';
import { RoleGuard } from './guards/role.guard';
import { SubmitGuard } from './guards/submit.guard';
import { DataEntryChallanListComponent } from './components/sidenav/pages/create-batch/data-entry-challan-list/data-entry-challan-list.component';
import { DataEntryChallanViewComponent } from './components/sidenav/pages/create-batch/data-entry-challan-view/data-entry-challan-view.component';
import { DataEntryChallanEditComponent } from './components/sidenav/pages/create-batch/data-entry-challan-edit/data-entry-challan-edit.component';
import { EditChallanComponent } from './components/sidenav/pages/create-batch/edit-challan/edit-challan.component';
import { IpGuard } from './guards/ip.guard';

const routes: Routes = [
  // { path: '', redirectTo: 'sign-in', pathMatch: 'full' },
  { path: '', component: SignInComponent },
  { path: 'sign-in', component: SignInComponent },
  { path: 'sign-in/:id', component: SignInComponent },

  {
    path: 'otp',

    component: OtpComponent,
    // canActivate: [OTPGuard],

    // canDeactivate: [SubmitGuard],

  },
  {
    path: 'otp/:id',
    component: OtpComponent
  },

  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'forgot-password', component: ForgotPasswordComponent },
  { path: 'change-password', component: ChangePasswordComponent },
  {
    path: 'access-restriction-page',
    component: AccessRestrictionComponent
  },

  // {
  //   path: 'sign-up', component: SignUpComponent
  // },
  // {
  //   path: 'forgot-password',
  //   component: ForgotPasswordComponent
  // },
  // {
  //   path: 'reset-password',
  //   component: ResetPasswordComponent
  // },
  // {
  //   path: 'change-password',
  //   canActivate: [AuthGuard],

  //   component: ChangePasswordComponent
  // },

  {
    path: '',
    // canActivate: [AuthGuard],
    canActivate: [AuthGuard],
    component: SideNavComponent,
    children: [
      //{ path: '', redirectTo: '/create-batch', pathMatch: 'full' },


      // {
      //   path: 'create-challan',
      //   component: CreateBatchComponent,
      //   canActivate: [RoleGuard],
      //   data: { roles: ['DATA ENTRY OPERATOR'] }
      // },
      // {
      //   path: 'data-entry-challan-list',
      //   component: DataEntryChallanListComponent,
      //   canActivate: [RoleGuard],
      //   data: { roles: ['DATA ENTRY OPERATOR'] }

      // },
      // {
      //   path: 'data-entry-challan-view/:id',
      //   component: DataEntryChallanViewComponent,
      //   canActivate: [RoleGuard],
      //   data: { roles: ['DATA ENTRY OPERATOR'] }

      // },
      // {
      //   path: 'data-entry-challan-edit/:id',
      //   component: DataEntryChallanEditComponent,
      //   canActivate: [RoleGuard],
      //   data: { roles: ['DATA ENTRY OPERATOR'] }

      // },
      // {
      //   path: 'view-challan',
      //   component: ViewChallanComponent,
      //   canActivate: [RoleGuard],
      //   data: { roles: ['VERIFIER'] }
      // },
      // {
      //   path: 'edit-challan',
      //   component: EditChallanComponent,
      //   canActivate: [RoleGuard],
      //   data: { roles: ['VERIFIER'] }
      // },
      // {
      //   path: 'edit-challan/:id',
      //   component: EditChallanComponent,
      //   canActivate: [RoleGuard],
      //   data: { roles: ['VERIFIER'] }
      // },
      // {
      //   path: 'view-challan/:id/:id2',
      //   component: ViewChallanComponent,
      //   canActivate: [RoleGuard],
      //   data: { roles: ['VERIFIER'] }
      // },
      // {
      //   path: 'onboard-container',
      //   component: OnboardContainerComponent,
      //   canActivate: [RoleGuard],
      //   data: { roles: ['VERIFIER'] }
      // },
      // {
      //   path: 'challan',
      //   component: ViewSingleChallanComponent,
      //   canActivate: [RoleGuard],
      //   data: { roles: ['VERIFIER'] }
      // },
      // {
      //   path: 'challan/:id',
      //   component: ViewSingleChallanComponent,
      //   canActivate: [RoleGuard],
      //   data: { roles: ['VERIFIER'] }
      // },
      // {
      //   path: 'challan/:id/:id2',
      //   component: ViewSingleChallanComponent,
      //   canActivate: [RoleGuard],
      //   data: { roles: ['VERIFIER'] }
      // },
      // {
      //   path: 'challan-list',
      //   component: ListOfChallansComponent,
      //   canActivate: [RoleGuard],
      //   data: { roles: ['VERIFIER'] }
      // },
      {
        path: 'data-entry-challan-list',
        loadChildren: () => import('./components/sidenav/pages/create-batch/create-batch.module').then(m => m.CreateBatchModule),
        canActivate: [RoleGuard],
        data: { roles: ['DATA ENTRY OPERATOR'] },
      },
      {
        path: 'verifier',
        loadChildren: () => import('./components/sidenav/pages/verifier/verifier.module').then(m => m.VerifierModule),
        canActivate: [RoleGuard],
        data: { roles: ['VERIFIER'] },
      },
      {
        path: 'importincharge',
        loadChildren: () => import('./components/sidenav/pages/import-incharge/import-incharge.module').then(m => m.ImportInchargeModule),
        canActivate: [RoleGuard],
        data: { roles: ['IMPORT IN-CHARGE'] },
      },
      {
        path: 'sample-assistant',
        loadChildren: () => import('./components/sidenav/pages/sample-assistant/sample-assistant.module').then(m => m.SampleAssistantModule),
        canActivate: [RoleGuard],
        data: { roles: ['SAMPLE ASSISTANT'] },
      },
      {
        path: 'lab-receiver',
        loadChildren: () => import('./components/sidenav/pages/lab-receiver/lab-receiver.module').then(m => m.LabReceiverModule),
        canActivate: [RoleGuard],
        data: {
          roles: ['LAB RECEIVER']
        },
      },

      {
        path: 'super-admin',
        loadChildren: () => import('./components/sidenav/pages/super-admin/super-admin.module').then(m => m.SuperAdminModule),
        canActivate: [RoleGuard],
        data: { roles: ['SUPER ADMIN'] },
      },
      {
        path: 'lab-ace',
        loadChildren: () => import('./components/sidenav/pages/Lab-Ace/lab-ace/lab-ace.module').then(m => m.LabAceModule),
        canActivate: [RoleGuard],
        data: { roles: ['LAB ACE'] },

      },
      {
        path: 'lab-analyst',
        loadChildren: () => import('./components/sidenav/pages/lab-analyst/lab-analyst/lab-analyst.module').then(m => m.LabAnalystModule),
        canActivate: [RoleGuard],
        data: { roles: ['LAB ANALYST'] },

      },
      {
        path: 'lab-admin',
        loadChildren: () => import('./components/sidenav/pages/lab-admin/lab-admin/lab-admin.module').then(m => m.LabAdminModule),
        canActivate: [RoleGuard],
        data: { roles: ['LAB ADMIN'] },

      },
      {
        path: 'ass-Import-Incharge',
        loadChildren: () => import('./components/sidenav/pages/asst-import-incharge/asst-import-incharge.module').then(m => m.AsstImportInchargeModule),
        canActivate: [RoleGuard],
        data: { roles: ['ASSISTANT IMPORT IN-CHARGE'] },

      },

      {
        path: 'access-restriction',
        component: AccessRestrictionComponent
      },

    ],
  },


];
;

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
